import React from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import Home from './Home';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import './App.css'; // Ensure you include the updated CSS
import DataDeletion from './DataDeletion';

const App = () => {
  return (
    <Router>
      <div className="App">
        {/* Navigation Bar */}
        <nav className="navbar">
          <a href="/" className="navbar-logo">Number Paint</a>
          <div className="navbar-links">
            <NavLink to="/" className={({ isActive }) => (isActive ? 'active' : '')}>
              Home
            </NavLink>
            <NavLink to="/privacy-policy" className={({ isActive }) => (isActive ? 'active' : '')}>
              Privacy Policy
            </NavLink>
            <NavLink to="/terms-of-service" className={({ isActive }) => (isActive ? 'active' : '')}>
              Terms Of Service
            </NavLink>
            <NavLink to="/data-deletion" className={({ isActive }) => (isActive ? 'active' : '')}>
              Data Deletion
            </NavLink>
          </div>
        </nav>
        {/* Application Routes */}
        <div className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/data-deletion" element={<DataDeletion />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
